import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Button, Icon, IconButton, Tooltip, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type TollFreeProfile } from 'entities/Compliance/model'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CompliancePath } from 'pages/settings/pages/compliance/route/compliancePath'
import { StatusesTF } from './StatusesTF/StatusesTF'
import styles from './styles.module.scss'

type ISummaryTollFreeItemProps = {
  allStepsLength: number
  item: TollFreeProfile
  openDeleteModal: (item: TollFreeProfile) => void
}

export const SummaryTollFreeItem: FC<ISummaryTollFreeItemProps> = observer(
  ({ allStepsLength, item, openDeleteModal }) => {
    const numbersCount = item.numberCount
    const isStatusInProgress = item.isStatusInProgress
    const completed = item.completed
    const { featureFlagsStore } = useEntitiesContext()

    const continueText = (
      <Typography ariaLabel='Continue' variant='button-medium'>
        {'Continue: '}
        <Typography
          ariaLabel='Step'
          variant='button-medium'
          color='var(--content-primary-tertiary-inverted)'
        >
          {`Step ${item.continueStep}/${allStepsLength}`}
        </Typography>
      </Typography>
    )

    const isCompleted = completed && numbersCount

    return (
      <div
        className={classNames(styles.wrap, {
          [styles.clickable]: isCompleted,
        })}
        onClick={() => {
          if (!isCompleted) return

          uiStore.changeRouteViaVue({
            path: `/${CompliancePath.compliance.tollFree.view(item.id)}`,
          })
        }}
      >
        <div className={styles.info}>
          <div className={styles.leftContent}>
            <Typography ariaLabel='AfterRegisterSectionLN_title' variant='body-md-medium'>
              {item.useCaseName || (
                <div className={styles.useCaseDefault}>
                  <Typography ariaLabel='example' variant='body-rg-regular'>
                    Use case name
                  </Typography>

                  <Tooltip label={'Name will be determined at step 4'} placement='top'>
                    <Icon icon='question' color='var(--gray-40)' fontSize={14} />
                  </Tooltip>
                </div>
              )}
            </Typography>
            <Typography
              ariaLabel='AfterRegisterSectionLN_desc'
              variant='body-md-regular'
              color='var(--content-primary-tertiary)'
            >
              {`${numbersCount} number`}
            </Typography>
          </div>
          <div className={styles.rightContent}>
            {isStatusInProgress && !completed && (
              <>
                <Button
                  text={continueText}
                  size='small'
                  className={styles.button}
                  onClick={() => {
                    if (featureFlagsStore.salesmsg_design_v2_compliance_toll_free) {
                      uiStore.changeRouteViaVue({
                        path: `/${CompliancePath.compliance.tollFree.viewSteps(item.id)}`,
                      })
                    } else {
                      window.publicApiVue?.onContinueTollFreeProfileModal(item.origin)
                    }
                  }}
                />
                <IconButton
                  ariaLabel='Delete'
                  icon='delete'
                  size='medium'
                  color={'tertiary'}
                  variant={'icon'}
                  onClick={() => openDeleteModal(item)}
                />
              </>
            )}
            {isCompleted && (
              <Icon
                ariaLabel='Check_condition'
                icon='chevronRight'
                color='var(--content-primary-tertiary)'
              />
            )}
          </div>
        </div>

        <StatusesTF item={item} />
      </div>
    )
  }
)
